(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["add-to-cart-button"] && !Shopify.designMode) return;
  try {
    /* BISOU PRODUCT PAGE CUSTOMIZATION
     Restores ADD TO CART · current price only inside the stable main product buy area wrapper.
  */
  (() => {
    const buyAreas = document.querySelectorAll('.bisou-main-product-buy-area');

    buyAreas.forEach((buyArea) => {
      const form = buyArea.querySelector('form') || buyArea.closest('form');
      const button = buyArea.querySelector('button[ref="addToCartButton"][name="add"], button[type="submit"][name="add"]');
      const label = button?.querySelector('.add-to-cart-text__content');
      const variantInput = form?.querySelector('input[name="id"]');
      const priceMapScript = buyArea.querySelector('[data-bisou-atc-price-map]');
      const baseLabel = buyArea.getAttribute('data-bisou-atc-label') || 'ADD TO CART';
      let priceMap = {};

      if (!button || !label) return;

      try {
        priceMap = priceMapScript ? JSON.parse(priceMapScript.textContent || '{}') : {};
      } catch (error) {
        priceMap = {};
      }

      const updateLabel = () => {
        if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

        const variantId = variantInput?.value;
        const price = priceMap[variantId] || buyArea.getAttribute('data-bisou-atc-price');
        if (!price) return;

        label.textContent = `${baseLabel} · ${price}`;
      };

      updateLabel();
      form?.addEventListener('change', () => window.setTimeout(updateLabel, 0));

      if (variantInput) {
        const observer = new MutationObserver(updateLabel);
        observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
      }
    });
  })();

  /* BISOU PRODUCT PAGE CUSTOMIZATION — MAIN CART DRAWER
     Opens the theme's existing cart drawer only after a successful native add from the main product buy area.
  */
  document.addEventListener('cart:update', (event) => {
    const eventSource = event.target instanceof Element ? event.target : null;
    const mainBuyArea = eventSource?.closest('.bisou-main-product-buy-area');

    if (!mainBuyArea || event.detail?.data?.didError) return;

    const cartDrawer = document.querySelector('cart-drawer-component');
    if (!cartDrawer || cartDrawer.hasAttribute('auto-open')) return;

    cartDrawer.open?.();
  });
  /* END BISOU PRODUCT PAGE CUSTOMIZATION — MAIN CART DRAWER */

  /* END BISOU PRODUCT PAGE CUSTOMIZATION */
  } catch(e) { console.error(e); }
})();

})();
